var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"filler-option-box white py-4 px-4 d-inline-flex justify-center align-center text-center",class:[
    {'light-blue': _vm.isChosen},
    {'white--text': _vm.isChosen}
  ],attrs:{"tile":""},on:{"click":_vm.choose}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }